import { useApolloClient } from "@apollo/client"
import { StatusLink } from "./styles"
import { navigateToEducationPgmPurchase } from "../../../../utils/educationPgmPurchase"

export const QualifyingLevel = ({ qualifyingLevel, history }) => {
  const client = useApolloClient()
  const materialsPurchased = qualifyingLevel?.materialsPurchased
  const handleQualifyingLevel = async () => {
    await navigateToEducationPgmPurchase({
      client,
      history,
      allowNextLevelPurchase: true,
    })
  }
  return (
    <>
      {materialsPurchased ? (
        <StatusLink href="https://pgaofamerica.instructure.com/">
          Access Education Portal
        </StatusLink>
      ) : (
        <StatusLink
          onClick={handleQualifyingLevel}
          data-testid="purchase-qualifying-level"
        >
          Purchase Qualifying Level
        </StatusLink>
      )}
    </>
  )
}

export default QualifyingLevel
